import { render, staticRenderFns } from "./UpgradeFeatureDialog.vue?vue&type=template&id=43a6d562&scoped=true&lang=pug&"
import script from "./UpgradeFeatureDialog.vue?vue&type=script&lang=js&"
export * from "./UpgradeFeatureDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeFeatureDialog.vue?vue&type=style&index=0&id=43a6d562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a6d562",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VDivider,VSpacer})
